import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useCart } from "@/context/CartContext";

export default function BasketRestore() {
  const { id } = useParams();
  const { replace } = useCart();
  const nav = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/basket/${id}`).then(({ data }) => {
      if (!data.items.length) return setErr("Sorry, the items in this basket are no longer available.");
      replace(data.items.map((i, k) => i.hamper
        ? { id: `hamper-${Date.now()}-${k}`, name: i.name, price: i.price, image_url: i.image_url, store: "Hamper", max: 5, qty: i.qty, hamper: i.hamper, contents: i.contents }
        : { id: i.id, name: i.name, price: i.price, image_url: i.image_url, store: i.store, max: Math.min(20, i.stock_qty ?? 20), qty: Math.min(i.qty, i.stock_qty ?? 20) }));
      nav("/checkout", { replace: true });
    }).catch((e) => setErr(errMsg(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="basket-restore-page">
      {err ? (
        <><h1 className="font-serif text-3xl font-bold" data-testid="basket-restore-error">{err}</h1><Link to="/" className="mt-6 inline-block underline">Browse the shop</Link></>
      ) : (
        <><Loader2 className="w-10 h-10 mx-auto animate-spin text-[#8C2220]" /><p className="mt-4">Restoring your basket…</p></>
      )}
    </div>
  );
}
